import { render, staticRenderFns } from "./CourseItem.vue?vue&type=template&id=1a4ac713"
import script from "./CourseItem.vue?vue&type=script&lang=ts"
export * from "./CourseItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports